import { useEffect, useRef, useState } from "react";
import { Star } from "lucide-react";

const reviews = [
  {
    name: "Maryam Seifi",
    text: "Their analysis pinpointed issues we had no idea about. They gave us a clear plan and helped us execute it quickly.",
  },
  {
    name: "Dr. Monil Shah",
    text: "They reviewed everything — our website, our ads, our Google profile — and showed us exactly where we were losing patients. Eye-opening.",
  },
  {
    name: "Dr. Munther Salem",
    text: "Hans broke down where our new-patient funnel was leaking. Within weeks we saw the difference. Truly data-driven.",
  },
];

const LandingGoogleReviews = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-10 bg-background border-t border-border/50" ref={ref}>
      <div className="max-w-4xl mx-auto section-padding">
        <div className={`flex flex-col items-center gap-6 ${visible ? "reveal-up" : "opacity-0"}`}>
          {/* Rating badge */}
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <span className="font-semibold text-foreground">5.0 on Google</span>
          </div>

          {/* Review snippets */}
          <div className="grid md:grid-cols-3 gap-4 w-full">
            {reviews.map((r) => (
              <div
                key={r.name}
                className="text-center px-4 py-3"
              >
                <p className="text-sm text-muted-foreground italic leading-relaxed mb-2">
                  "{r.text}"
                </p>
                <p className="text-xs font-medium text-foreground">{r.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingGoogleReviews;
